// src/components/ws/WsDeviceSharing.jsx
// 出席集計の「同じ端末」タブ【2026-11-02】
//   この授業で、同じ端末から複数の人が打刻した回を、新しい回から並べる。
//   上に学生ごとのまとめ（代わりに打刻された回数／ほかの人の分を打った回数）。
import React, { useCallback, useEffect, useState } from 'react';
import DeviceSharingList, { summarizeByStudent } from '../DeviceSharingList';
import { authHeaders } from './wsCommon';

export default function WsDeviceSharing({ classId, setErr }) {
  const [groups, setGroups] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await fetch('/api/attendance/device-sharing/' + classId, { headers: authHeaders(false) });
      const d = await r.json();
      if (!d.success) throw new Error(d.message || '読み込めませんでした');
      setGroups(d.groups || []);
    } catch (e) { setGroups([]); setErr(e.message); }
  }, [classId, setErr]);
  useEffect(() => { load(); }, [load]);

  if (groups === null) return <div className="ws-pad ws-muted">読み込み中…</div>;
  const people = summarizeByStudent(groups);

  return (
    <div className="ws-pad dsh-tab">
      <p className="ws-muted dsh-intro">
        同じ回に、同じスマホから2人以上が打刻した記録です。友だちに打刻してもらうこと（ほかの人のスマホでの打刻）は認めていません。
        端末の「持ち主」は、その端末でいちばん多く打刻している人（すべての授業を合わせて）とみなし、持ち主以外の人を「代わりに打刻された」としています。
        代わりに打刻された学生には、アプリに「認めていません。どうしてもほかの人のスマホを使うしかなかった場合は先生に伝えてください」と知らせています。
        出席の記録は受け取ったまま残しているので、扱いは先生が決めてください（出欠は「出欠の確認・修正」で直せます）。
      </p>
      {groups.length === 0 ? (
        <div className="dsh-empty">同じ端末からの出席はありません。</div>
      ) : (
        <>
          <h3 className="dsh-h">学生ごと</h3>
          <table className="data-table dsh-people">
            <thead><tr><th>学籍番号</th><th>氏名</th><th>代わりに打刻された</th><th>ほかの人の分を打った</th><th>持ち主がはっきりしない</th></tr></thead>
            <tbody>
              {people.map(p => (
                <tr key={p.userId}>
                  <td>{p.studentId}</td><td>{p.name}</td>
                  <td className={p.proxied ? 'dsh-num-warn' : ''}>{p.proxied ? p.proxied + '回' : '—'}</td>
                  <td className={p.proxying ? 'dsh-num-warn' : ''}>{p.proxying ? p.proxying + '人分' : '—'}</td>
                  <td>{p.unclear ? p.unclear + '回' : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <h3 className="dsh-h">回ごと（{groups.length}件）</h3>
          <DeviceSharingList groups={groups} />
        </>
      )}
    </div>
  );
}
